import { render } from "./VendimetPage.vue?vue&type=template&id=3ec409c0&scoped=true"
import script from "./VendimetPage.vue?vue&type=script&lang=js"
export * from "./VendimetPage.vue?vue&type=script&lang=js"

import "./VendimetPage.vue?vue&type=style&index=0&id=3ec409c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec409c0"]])

export default __exports__